import { AirlineModel } from 'api-hooks/airline';
import React from 'react';

import { AirlineFormType } from '../components/form-type';

export default function useAirlineDefaultValues(airline?: AirlineModel) {
  const defaultValues = React.useMemo<AirlineFormType>(() => {
    return {
      code: airline?.code || '',
      email: airline?.email || '',
      phone: airline?.phone || '',
      phone_2: airline?.phone_2 || '',
      address: airline?.address || '',
      name: airline?.name || '',
      preferences: airline?.preferences || [],
      contact: {
        id: airline?.contact?.id,
        name: airline?.contact?.name || '',
        email: airline?.contact?.email || '',
        phone: airline?.contact?.phone || '',
        description: airline?.contact?.description || '',
      },
    };
  }, [airline]);

  return defaultValues;
}
